import { render } from "./EmployeeAdvanceRequest.vue?vue&type=template&id=7d964255"
import script from "./EmployeeAdvanceRequest.vue?vue&type=script&lang=js"
export * from "./EmployeeAdvanceRequest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__